// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_es_mjs":"778c40f57cfe45cb","node_modules_canvg_lib_index_es_js":"20695d5f96eb530c"}[chunkId] + ".js";
};